import { EditorContent as TipTapEditorContent } from "@tiptap/react";
import { styled } from "@mui/material/styles";

const StyledTipTapEditorContent = styled(TipTapEditorContent)`
  .ProseMirror {
    outline: none;
  }
  & blockquote {
    border-left: 3px solid #37352f80;
    padding-left: 1rem;
  }
  & pre {
    background-color: ${({ theme }) => theme.palette_custom.darkBlue};
    color: ${({ theme }) => theme.palette_custom.white};
    padding: 8px 8px;
  }
  p {
    margin: 0;
  }
  img {
    cursor: pointer;
  }
  img.ProseMirror-selectednode {
    border: 2px solid ${({ theme }) => theme.palette_custom.darkBlue};
  }
`;

const EditorContent = ({ editor }) => {
  return editor && <StyledTipTapEditorContent editor={editor} />;
};

export default EditorContent;
